<template>
	<el-collapse-transition>
		<div v-show="show" :id="rowId">
			<slot />
		</div>
	</el-collapse-transition>
</template>

<script>
import { EventBus } from '@/main/eventBus';
import { rowCloseEvent } from '@/main/utils/table';

export default {
	name: 'DmsExpandedRow',
	props: {
		rowKey: { type: String, required: true },
	},
	data() {
		return {
			show: false,
		};
	},
	computed: {
		rowId() {
			return `expanded-row-${this.rowKey}`;
		},
	},
	mounted() {
		this.$nextTick(() => { this.show = true; });
		EventBus.$on(rowCloseEvent(this.rowKey), this.close);
	},
	methods: {
		close() {
			this.show = false;
		},
	},
};
</script>

<style scoped>

</style>
